import React, { useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import supabase from '../supabaseClient/supabaseClient';

const PrivateRoute = ({ element: Element, ...rest }) => {
  const [loading,setLoading]=useState(true);
  const [authenticated,setAuthenticated]=useState(false);
  const location=useLocation();
  useEffect(()=>{
    let active=true,observedAuthEvent=false;
    const update=session=>{
      if(!active)return;
      if(!session)sessionStorage.setItem('worksheep-return-path',location.pathname+location.search);
      setAuthenticated(Boolean(session));setLoading(false);
    };
    supabase.auth.getSession().then(({data:{session}})=>{if(!observedAuthEvent)update(session);}).catch(()=>{if(!observedAuthEvent)update(null);});
    const {data:{subscription}}=supabase.auth.onAuthStateChange((_event,session)=>{observedAuthEvent=true;update(session);});
    return()=>{active=false;subscription.unsubscribe();};
  },[location.pathname,location.search]);
  if(loading)return <div className="auth-container"><div className="loading-spinner" /></div>;
  return authenticated?<Element {...rest}/>:<Navigate to="/login" replace />;
};
export default PrivateRoute;
